import { CREATE_REFERENCE, CREATE_REFERENCE_FAILED, CREATE_REFERENCE_SUCCESS, GETALL_REFERENCES, GETALL_REFERENCES_FAILED, GETALL_REFERENCES_SUCCESS, UPDATE_REFERENCE, UPDATE_REFERENCE_FAILED, UPDATE_REFERENCE_SUCCESS, UPLOAD_REF_FILES, UPLOAD_REF_FILES_FAILED, UPLOAD_REF_FILES_SUCCESS, VIEW_REF_FILES, VIEW_REF_FILES_FAILED, VIEW_REF_FILES_SUCCESS, DOWNLOAD_REFERENCE, DOWNLOAD_REFERENCE_SUCCESS, DOWNLOAD_REFERENCE_FAILED } from "./ActionTypes";

export const getAllReferences = () =>({
    type : GETALL_REFERENCES
})

export const referenceDownload = () => ({
    type: DOWNLOAD_REFERENCE,
})

export const getAllReferencesSuccess = (payload) =>({
    type : GETALL_REFERENCES_SUCCESS,
    payload
})


export const getAllReferencesFailed = (payload) =>({
    type : GETALL_REFERENCES_FAILED,
    payload
})


export const createReference = (payload) =>({
    type: CREATE_REFERENCE,
    payload
})

export const createReferenceSuccess = (payload) =>({
    type: CREATE_REFERENCE_SUCCESS,
    payload
})

export const createReferenceFailed = (payload) =>({
    type: CREATE_REFERENCE_FAILED,
    payload
})


export const updateReference = (payload) =>({
    type: UPDATE_REFERENCE,
    payload
})


export const updateReferenceSuccess = (payload) =>({
    type: UPDATE_REFERENCE_SUCCESS,
    payload
})

export const updateReferenceFailed = (payload) =>({
    type: UPDATE_REFERENCE_FAILED,
    payload
})


export const viewRefFiles = (payload) =>({
    type: VIEW_REF_FILES,
    payload
})

export const viewRefFilesSuccess = (payload) =>({
    type: VIEW_REF_FILES_SUCCESS,
    payload
})

export const viewRefFilesFailed = (payload) =>({
    type: VIEW_REF_FILES_FAILED,
    payload
})



export const uploadRefFiles = (payload) =>({
    type: UPLOAD_REF_FILES,
    payload
})

export const uploadRefFilesSuccess = (payload) =>({
    type: UPLOAD_REF_FILES_SUCCESS,
    payload
})

export const uploadRefFilesFailed = (payload) =>({
    type: UPLOAD_REF_FILES_FAILED,
    payload
})


export const referenceDownloadSuccess = (payload) => ({
    type: DOWNLOAD_REFERENCE_SUCCESS,
    payload
})

export const referenceDownloadFailed = (payload) => ({
    type: DOWNLOAD_REFERENCE_FAILED,
    payload
})